'use client';
import React from 'react';
import Image from 'next/image';
import MWSVG from '@/components/common/svg';

const deepHighlights = [
    '18+ years in enterprise software and AI systems',
    'Led hundreds of projects project delivery cycles across global markets',
    'ISO 27001 and CMMI L3 certified delivery organization',
    'Offices and delivery teams in India and the USA',
    'Trusted by clients in FinTech, Healthcare, Logistics, Real Estate, and more',
];

const UsaMeetDeep = () => {
    return (
        <section className="section-py" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 gap-10 items-center">
                    {/* Left: Image */}
                    <div
                        className="lg:col-span-5 flex justify-center"
                        data-aos="fade-right"
                        data-aos-duration="1000"
                        data-aos-delay="200"
                    >
                        <Image
                            src="/img/lets-meet-usa/deep-trivedi.svg"
                            alt="Deep Trivedi – CEO, Moweb"
                            width={400}
                            height={585}
                            className="img-fluid rounded-10 object-cover"
                            loading="lazy"
                        />
                    </div>

                    {/* Right: Content */}
                    <div className="lg:col-span-7 flex flex-col gap-5">
                        <div>
                            <h2 className="text-primary mb-4">Meet Deep Trivedi</h2>
                            <div className="fw-700 text-md">
                                <span className="gradient-text">CTO, Moweb Technologies</span>
                            </div>
                        </div>

                        <p className="fs-md fw-400 text-secondary dark:text-[#D7DEE5] mb-0">
                            Deep Trivedi leads technology strategy, AI delivery, and engineering at Moweb Technologies. With
                            nearly two decades of experience in enterprise software and AI systems, Deep works directly with
                            enterprise leaders, founders, and technology teams to translate business goals into working, scalable
                            digital solutions.
                        </p>

                        <p className="fs-md fw-400 text-secondary dark:text-[#D7DEE5] mb-0">
                            During his USA visit from 7 May to 27 June 2026, Deep is available for selective 1:1 conversations
                            across AI strategy, enterprise modernization, data engineering, and product engineering.
                        </p>

                        <div className="flex flex-col gap-2.5">
                            {deepHighlights.map((point, i) => (
                                <div key={i} className="flex items-start gap-2.5 fs-md text-secondary dark:text-[#D7DEE5]">
                                    <MWSVG
                                        id="tabler-icon-square-rounded-check-filled"
                                        svgClassName="me-0 mt-[2px] min-w-[24px]"
                                    />
                                    {point}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UsaMeetDeep;
